import { render } from "./MembershipDetailsVisitsTab.vue?vue&type=template&id=623a1241"
import script from "./MembershipDetailsVisitsTab.vue?vue&type=script&lang=js"
export * from "./MembershipDetailsVisitsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__